import { forwardRef } from 'react';
import { EmptyStateProps } from './types';
import clsx from 'clsx';

/**
 *  UI Component
 */
const EmptyState = forwardRef<HTMLDivElement, EmptyStateProps>(
  function EmptyState(props, ref) {
    // Apply Default props values
    props = {
      ...{
        color: undefined,
        size: undefined
      },
      ...props
    };

    const {
      className,
      children,
      icon,
      image,
      label,
      additionalText,
      imageClassName,
      ...rest
    } = props;

    const cls = styleEmptyState(props);
    return (
      <div className={clsx(cls.main, className)} ref={ref} {...rest}>
        {image ? (
          <img
            className={clsx(cls.image, imageClassName)}
            src={image}
            loading="lazy"
            alt={label}
          />
        ) : (
          icon && <span className={clsx(cls.icon)}>{icon}</span>
        )}
        <span className={clsx(cls.label)}>{label}</span>
        {additionalText && (
          <span className={clsx(cls.additional)}>{additionalText}</span>
        )}
      </div>
    );
  }
);

export default EmptyState;

/**
 * Assign classNames to component based on properties
 */
function styleEmptyState(props: EmptyStateProps) {
  const mc = 'EmptyState';
  const cls = {
    main: [mc],
    image: [`${mc}__Image`],
    icon: [`${mc}__Icon`],
    label: [`${mc}__Label`],
    additional: [`${mc}__Additional`]
  };
  return cls;
}
